import { Form } from '@extend/antd/form';
import { Col, Row, Typography } from 'antd';
import TableRefresherPrivacyLogs from './components/TableRefresherPrivacyLogs';
import ManageLogsProvider from './contexts/manage-logs.context';
import React from 'react';
import PaginationPrivacyLogs from './components/PaginationPrivacyLogs';
import SearchPrivacyLogs from './components/SearchPrivacyLogs';
import TableDataPrivacyLogs from './components/TableDataPrivacyLogs';
import { Drawer } from '@extend/antd/drawer';

const PrivacySystemLogs = () => {
  return (
    <ManageLogsProvider>
      <Row type="flex" gutter={[10, 10]}>
        <Col xs={24}>
          <Typography.Title level={4}>Logs</Typography.Title>
        </Col>
        <Col xs={24}>
          <Form.Provider>
            <SearchPrivacyLogs />
          </Form.Provider>
        </Col>
        <Col xs={24}>
          <TableRefresherPrivacyLogs />
        </Col>
        <Col xs={24}>
          <Drawer.ViewJSONProvider>
            <TableDataPrivacyLogs />
          </Drawer.ViewJSONProvider>
        </Col>
        <Col xs={24}>
          <PaginationPrivacyLogs />
        </Col>
      </Row>
    </ManageLogsProvider>
  );
};

export default PrivacySystemLogs;
